// Angular dependencies
import 'angular'
import 'angular-animate'
import 'angular-breadcrumb'
import 'angular-cookie'
import 'angular-cookies'
import 'angular-gettext'
import 'angular-loading-bar'
import 'angular-local-storage'
import 'angular-notify'
import 'angular-resource'
import 'angular-sanitize'
import 'angular-touch'
import 'angular-bootstrap-npm'
import 'angular-ui-switch'
import 'angular-validation'
import '@uirouter/angularjs'

// Non-angularjs dependencies.
import 'lodash'
import $ from 'jquery'
import Auth from '@aws-amplify/auth'
import getLocaleFromUrl from '@ui/shared-utils/src/getLocaleFromUrl'

window.AwsAuth = Auth
window.jQuery = $
window.$ = $
window.getLocaleFromUrl = getLocaleFromUrl